import { InspectionService } from './../../../inspection/shared/services/inspection.service';
import {AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AttachmentPreviewModalComponent} from '../attachment-preview-modal/attachment-preview-modal.component';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { ModalService } from '../modal/modal.service';

@Component({
  selector: 'app-attachment-list',
  templateUrl: './attachment-list.component.html',
  styleUrls: ['./attachment-list.component.scss']
})
export class AttachmentListComponent implements OnInit, AfterViewInit {

  @Input() tableModel = {header: [], data: [], options: {}};

  @ViewChild('documentActionTemplate')
  private documentActionTemplate: TemplateRef<any>;

  
  constructor(private httpService: HttpClient, private modalService: ModalService, private sharedService: InspectionService) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.tableModel.header.find(h => h.isTemplate).templateRef = this.documentActionTemplate;
  }

  previewAttachment(documentInfo: any): void {
    this.modalService.open({
      content: AttachmentPreviewModalComponent,
      componentParams: {
        document: documentInfo
      },
      modalOptions: {
        modalTitle: documentInfo.title,
        size: 'lg'
      },
    });
  }

  downloadAttachment(documentInfo: any): void {
    this.sharedService.downloadAttachment(documentInfo);
  }
}
